import './CampaignListTrigger.css';

import { useState } from 'react';
import { Alert, Col, Container, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import LoadingButton from 'components/LoadingButton/LoadingButton';
import User from 'utils/user.util';

function CampaignListTrigger({ property }) {
    const { t } = useTranslation();
    const [campaignName, setCampaignName] = useState('');
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState({ show: false, variant: 'success', message: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setAlert({ show: false, variant: 'success', message: '' });
        setLoading(true);

        try {
            const token = User.getToken();
            const response = await fetch(
                `${process.env.REACT_APP_PROXY_URL || ''}/api/campaign_trigger`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        propertyId: property.external_id__c,
                        campaignName: campaignName.trim(),
                    }),
                }
            );

            if (response.ok) {
                setAlert({
                    show: true,
                    variant: 'success',
                    message: t('campaign_trigger_success'),
                });
                setCampaignName('');
            } else {
                setAlert({ show: true, variant: 'danger', message: t('campaign_trigger_error') });
            }
        } catch {
            setAlert({ show: true, variant: 'danger', message: t('campaign_trigger_error') });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="campaign-list-trigger">
            <Row>
                <Col>
                    <h2 className="campaign-list-trigger-title">{t('campaign_list_trigger')}</h2>
                </Col>
            </Row>

            {alert.show && (
                <Row>
                    <Col>
                        <Alert
                            variant={alert.variant}
                            onClose={() =>
                                setAlert({ show: false, variant: 'success', message: '' })
                            }
                            dismissible
                        >
                            {alert.message}
                        </Alert>
                    </Col>
                </Row>
            )}

            <Row>
                <Col>
                    <p>{t('campaign_list_trigger_description')}</p>
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="campaignName">
                            <Form.Label>{t('campaign_name')}</Form.Label>
                            <Form.Control
                                type="text"
                                value={campaignName}
                                onChange={(e) => setCampaignName(e.target.value)}
                                maxLength={200}
                                required
                                disabled={loading}
                            />
                        </Form.Group>
                        <LoadingButton
                            type="submit"
                            isLoading={loading}
                            isDisabled={campaignName.trim() === ''}
                            maxWidth="none"
                        >
                            {t('trigger_campaign')}
                        </LoadingButton>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
}

export default CampaignListTrigger;
